export function WarningBanner() {
  return (
    <div className="w-full bg-red-500  py-2">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-center gap-2">
          <p className="text-small text-center font-medium text-text-primary">
            You are currently on the iExchange Testnet. All transactions are for testing purposes only. DO NOT USE REAL
            FUNDS.
          </p>
        </div>
      </div>
    </div>
  );
}
